import { Dispatch, SetStateAction, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components';
import Spinner from '../../../components/common/Spinner';
import { toggleDepositUlxModal } from '../../../slices/portfolio-slice';
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { DepositStepsEnum } from './types';
import { TokensType } from '../../../types/types';

interface DepositUlxProps {
  token: TokensType;
  depositStep: number;
  setDepositStep: Dispatch<SetStateAction<DepositStepsEnum>>;
  ulx: string;
  usdt: string;
  setUlx: Dispatch<SetStateAction<string>>;
  setUsdt: Dispatch<SetStateAction<string>>;
}

export const DepositUlx = ({
  token,
  setDepositStep,
  depositStep,
  ulx,
  usdt,
  setUlx,
  setUsdt
}: DepositUlxProps) => {
  const dispatch = useAppDispatch();

  const { loadingDepositUlx, depositUlxModal } = useAppSelector(
    (state) => state.portfolio
  );

  const { walletSummary } = useAppSelector((state) => state.marketplace);

  const [selectedNetwork, setSelectedNetwork] = useState<any>();

  const depositSteps = (step: DepositStepsEnum) => {
    switch (step) {
      case DepositStepsEnum.COMPLETE_DEPOSIT:
        return (
          <Step1
            setDepositStep={setDepositStep}
            wallet={walletSummary?.userAddress}
            token={token}
            ulx={ulx}
            usdt={usdt}
            setUlx={setUlx}
            setUsdt={setUsdt}
            selectedNetwork={selectedNetwork}
            setSelectedNetwork={setSelectedNetwork}
          />
        );

      case DepositStepsEnum.SELECT_PAYMENT:
        return (
          <Step2
            wallet={walletSummary?.userAddress}
            token={token}
            selectedNetwork={selectedNetwork}
          />
        );

      case DepositStepsEnum.FINISH:
        return <Step3 />;

      default:
        break;
    }
  };

  const depositStepsTitle = (step: DepositStepsEnum) => {
    switch (step) {
      case DepositStepsEnum.COMPLETE_DEPOSIT:
        return `COMPLETE  ${
          token.token === 'Ultron (ULX)' ? 'ULX' : 'AK1111'
        } DEPOSIT`;

      case DepositStepsEnum.SELECT_PAYMENT:
        return `ADD ${
          token.token === 'Ultron (ULX)' ? 'wULX' : 'AK1111'
        } TO YOUR BACK OFFICE WALLET`;

      case DepositStepsEnum.FINISH:
        return '';

      default:
        break;
    }
  };

  return (
    <div>
      <SidebarModal
        isOpen={depositUlxModal}
        setOpen={(v) => {
          dispatch(toggleDepositUlxModal(v));
          setDepositStep(DepositStepsEnum.COMPLETE_DEPOSIT);
          setSelectedNetwork('');
        }}
        title={depositStepsTitle(depositStep)}
        sidebarWidth={'560px'}>
        {loadingDepositUlx && <Spinner transparent absolute />}
        {depositSteps(depositStep)}
      </SidebarModal>
    </div>
  );
};
